export default "Harberger Taxation <b>need additional regulation</b> to protect individuals.\n";